"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormRichSelectMenu", {
    enumerable: true,
    get: function() {
        return FormRichSelectMenu;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormGroupContext = require("../../../../contexts/FormGroupContext");
const _FormRichSelectContext = require("../FormRichSelectContext");
const _Theme = require("../../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormRichSelectMenu = (param)=>{
    let { children } = param;
    const { x, y, strategy, open: show, floating } = (0, _react.useContext)(_FormRichSelectContext.FormRichSelectContext);
    const { colors, borderRadius, zIndexes } = (0, _Theme.useTheme)();
    const { id, labelId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    return /*#__PURE__*/ _react.default.createElement("div", {
        id: id,
        ref: floating,
        role: "listbox",
        "aria-labelledby": labelId,
        className: _style.default.dynamic([
            [
                "13596e8976ee663c",
                [
                    show ? "block" : "none",
                    colors.white,
                    colors.border,
                    borderRadius,
                    colors.dark,
                    zIndexes.dropdown,
                    strategy,
                    y !== null && y !== void 0 ? y : "",
                    x !== null && x !== void 0 ? x : ""
                ]
            ]
        ])
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "13596e8976ee663c",
        dynamic: [
            show ? "block" : "none",
            colors.white,
            colors.border,
            borderRadius,
            colors.dark,
            zIndexes.dropdown,
            strategy,
            y !== null && y !== void 0 ? y : "",
            x !== null && x !== void 0 ? x : ""
        ]
    }, "div.__jsx-style-dynamic-selector{display:".concat(show ? "block" : "none", ";background:").concat(colors.white, ";border:1px solid ").concat(colors.border, ";-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";color:").concat(colors.dark, ";max-height:200px;overflow-y:auto;z-index:").concat(zIndexes.dropdown, ";position:").concat(strategy, ";top:").concat(y !== null && y !== void 0 ? y : "", ";left:").concat(x !== null && x !== void 0 ? x : "", ";margin-top:4px;-webkit-box-shadow:0px 8px 24px rgba(0,0,0,.25);-moz-box-shadow:0px 8px 24px rgba(0,0,0,.25);box-shadow:0px 8px 24px rgba(0,0,0,.25)}")));
};
FormRichSelectMenu.displayName = "FormRichSelectMenu";

//# sourceMappingURL=FormRichSelectMenu.js.map